import BadgeIsValid from '~/components/BadgeIsValid'
import Panel from '~/components/Panel'
import { FormGroup, Input, InputMask, Label } from '~/components/unform'
import { useAppInfo } from '~/hooks/useAppInfo'
import { useAPPTranslation } from '~/i18n/useAPPTranslation'

import { useRechargeForm } from '../../../../hooks/useRechargeForm'
import { IdentificationNumber } from '../IdentificationNumber'

export const BillingInformationFieldset = () => {
  const { country } = useAppInfo()
  const { personStepIsValid } = useRechargeForm()
  const { t } = useAPPTranslation()

  // Obtém o padrão de telefone baseado no país, com fallback para BR
  const phoneKey = `c:patterns.phone.${country}` as string
  // @ts-expect-error - Dynamic i18n key based on country code
  const phoneFormat = t(phoneKey) || t('c:patterns.phone.BR')

  return (
    <Panel
      title={t('rm:payment.billing.title')}
      description={t('rm:payment.billing.description')}
      className="form-grid"
      iconLeft={<BadgeIsValid isValid={personStepIsValid} />}
    >
      <IdentificationNumber />

      <FormGroup className="span-start">
        <Label>{t('rm:payment.billing.name.label')}</Label>
        <Input
          name="name"
          placeholder={t('rm:payment.billing.name.placeholder')}
          required
        />
      </FormGroup>

      <FormGroup className="span2">
        <Label>{t('rm:payment.billing.phone.label')}</Label>
        <InputMask
          name="phone"
          format={phoneFormat}
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore - placeholder is passed via rest props to NumberFormat
          placeholder={t('rm:payment.billing.phone.placeholder')}
          mask="_"
          required
        />
      </FormGroup>

      <FormGroup className="span2">
        <Label>{t('rm:payment.billing.email.label')}</Label>
        <Input
          id="form-checkout__cardholderEmail"
          name="email"
          placeholder={t('rm:payment.billing.email.placeholder')}
          required
        />
      </FormGroup>
    </Panel>
  )
}
